import { type MouseEvent, useState, type FC, type ReactNode, type KeyboardEvent } from 'react';
import { useDispatch } from 'react-redux';
import { studentDashboardActions } from 'StudentDashboardSlice';

const ExpandableContainer: FC<{
    className?: string;
    children: ReactNode;
    onKeyDown: (e: KeyboardEvent) => void;
    onClick: (e: MouseEvent) => void;
    onKeyUp?: (e: KeyboardEvent) => void;
}> = ({ className, children, onKeyDown, onClick, onKeyUp }) => (
    <div role="button" tabIndex={0} onKeyDown={onKeyDown} className={className} onClick={onClick} onKeyUp={onKeyUp}>
        {children}
    </div>
);

export const useExpandableContainer = (
    { initiallyExpanded = false, itemId }: { initiallyExpanded: boolean; itemId?: string } = {
        initiallyExpanded: false,
        itemId: '',
    },
) => {
    const [open, setOpen] = useState(initiallyExpanded);
    const dispatch = useDispatch();

    // Omit argument to toggle open/close, or pass true to open, false to close
    const toggleOpen = (shouldOpen?: boolean) => {
        const nextOpen = shouldOpen ?? !open;

        if (open && !nextOpen && itemId) {
            // If transitioning from open to closed, unset any forced expanded state for this item
            dispatch(studentDashboardActions.resetForceExpandContentItem({ itemId }));
        }

        setOpen(nextOpen);
    };
    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            toggleOpen();
        }
    };

    return { open, toggleOpen, handleKeyDown, ExpandableContainer };
};
